// MAIN PAGE - applies to all pages
page.main.initOnce = function(){
    log.page("> INIT: FIRST LOAD");

    var v = page.main.v;
    var t_stickyMarket = 1;

    v.marketSticky = new TimelineMax({paused: true});

    v.marketSticky
        .to('.sticky-market', t_stickyMarket, { autoAlpha: 1}, 0.6);

    v.menuT2 = new TimelineMax();
    v.menuT2.pause();

    v.menuT2
        .to('.mobile-menu--bg', 0.35, {
            autoAlpha: 0.7
        });

    v.tableSlideTl = new TimelineMax();


    v.tableSlideTl.pause();


    v.wWidth = $(window).width();

    $('.header-logo a').click(function(e){
        e.preventDefault();
        if($(this).hasClass('scrollTop')){
            $.scrollify.move(0);
        }
    });

    $('.mobile-nav-main a').click(function(){

        $('.mobile-menu, .mobile-menu--bg').removeClass('active');
        v.menuT2.reverse();
    });

    $('.toggle-lang a').click(function(){
        $('.mobile-menu, .mobile-menu--bg').removeClass('active');
        v.menuT2.reverse();
    });


    $('.mobile-menu--bg').click(function(e){
        $('.mobile-menu, .mobile-menu--bg').removeClass('active');
        v.menuT2.reverse();
    });


    $('.header-main-nav a').click(function(){
        $('.header-main-nav a').removeClass('active');
        $(this).addClass('active');
    });

    $('.header-logo .ajax-barb').click(function(e){
        $('.ajax-barb').removeClass('active');
    });



    page.main.fr.setStickyMarker.init(stickyStart,false);

    v.pageReady = true;

    if(displayCarrier && $('.barba-container').data('namespace') !== 'contacts'){
        $('.sticky-career').addClass('active');
    }else{
        $('.sticky-career').removeClass('active');
    }
    let magicScroll = page.main.fr.magicScroll;

    let wWidth = $(window).width();

    if(magicScroll.controller === null && wWidth >= 1024) {
        page.main.fr.magicScroll.init();
    }

    page.main.fr.stupidMenu.init();


};

page.popupforms = {
    trigger : $('.popup-trigger'),
    close : $('.form-popup--close'),
    forms : $('.form-popup, .form-general'),
    swap : $('.swap-forms'),
    init : function() {

        if($('.section-news').length > 0){
            $('.section-news').bind('contextmenu',function(e){
                e.preventDefault();
            })
        }

        let obj = page.popupforms;

        obj.trigger = $('.popup-trigger');

        obj.close = $('.form-popup--close');
        obj.forms = $('.form-popup, .form-general');
        obj.swap = $('.swap-forms');


        let $trigger = obj.trigger;
        let $close = obj.close;
        let $forms = obj.forms;
        $trigger.click(function (e) {
            e.preventDefault();
            let $this = $(this);
            let target = $this.data('target');
            $forms.removeClass('active');

            //$(target).find('.label-float input').val('');
            //$(target).find('.label-float input').val('');
            $(target).addClass('active');
            $('.msg-success').hide();

        });

        $close.click(function (e) {
            e.preventDefault();
            $(this).parent().removeClass('active');

            $('.sub-login').addClass('active');
            $('.sub-reminder').removeClass('active');
            $('.sub-settings').show();
            


        });

        console.log('derp');
        $forms.find('.form').submit(function(e){
            e.preventDefault();
            let $this = $(this);
            let data = $this.serialize();
            let $msg = $this.find('.form-message');
            let $btn = $this.find('.submib-bt');
            $this.find('.error').removeClass('error');
            if($btn.length > 0){
                $btn[0].disabled = true;
            }

            $.ajax({
                data: data,
                type: 'post',
                url: ajaxurl,
                statusCode: {
                    503: function(xhr) {
                        $('#reg-login').parent().addClass('error').find('.field-error').html('Neteisingas el.paštas arba slaptažodis.');
                        $('#reg-pass').parent().addClass('error');
                        $btn[0].disabled = false;
                    }
                },
                success: function (data,textStatus, xhr) {
                    data = JSON.parse(data);

                    if(data.status == 0 && data.reload == true){
                        window.location.href = window.location.href;
                        return false;
                    }

                    if(data.status == 0){
                        for (const [key, value] of Object.entries(data.errors)) {
                            $('#reg-'+key).parent().addClass('error').find('.field-error').html(value);
                        }
                        if($btn.length > 0){
                            $btn[0].disabled = false;
                        }

                        return;
                    }

                    if(data.status == 1 && data.redirect == true) {
                        console.log(data.redirect_url)
                        if (data.redirect_url.length > 0) {
                            Barba.Pjax.goTo(data.redirect_url);
                        } else {
                            Barba.Pjax.goTo($this.find('.form-redirect').attr('href'));
                        }
                    }


                    if(data.status == 1 && data.change_name !== null && typeof data.change_name !== 'undefined'){
                        $('.news-subscriber--displayName').html(data.change_name);

                        if($btn.length > 0){
                            $btn[0].disabled = false;
                        }
                        return;
                    }
                    if(data.status == 1 && data.success == true){
                        $this.hide().next().html(data.msg).show();
                        $this.find('.step1').hide();
                        $this.find('.step2').show();
                        if($btn.length > 0){
                            $btn[0].disabled = false;
                        }

                        return;
                    }

                    if(data.status == 3){
                        $msg.html(data.notice).addClass('error').show();

                        $this.find('.step1 , .step2 , .step-controls').hide();

                        if($btn.length > 0){
                            $btn[0].disabled = false;
                        }
                        return;

                    }
                    if(data.status == 4){
                        $msg.html(data.notice).addClass('error').show();
                        $this.find('.step1').hide();
                        $this.find('.step2').show();
                        if($btn.length > 0){
                            $btn[0].disabled = false;
                        }
                    }

                }
            });
        });


        obj.swap.click(function(e){
            e.preventDefault();
            $('.sub-form').toggleClass('active');
        });

        $('.ajax-loggout').click(function(e){
            e.preventDefault();

            let $form = $('#logout');
            $.ajax({
                type: 'POST',
                url: ajaxurl,
                data: $form.serialize(),
                success: function(data){
                    data = JSON.parse(data);
                    if(data.status == 1 && data.redirect == true){
                        Barba.Pjax.goTo($form.find('.redirect').val());
                    }
                    if(data.status == 1 && data.redirect == false) {
                        location.reload();
                    }
                }
            });


        })



    },
    destroy: function(){

        $('.section-news').off();


        page.popupforms.trigger.off();
        page.popupforms.close.off();
        page.popupforms.forms.off();

        $('.ajax-loggout').off();
    }

};


page.transitions = function(name, time){
    log.page(`TRANSITION: ${name}`);

    if(typeof gtag !== 'undefined'){
        gtag('event', 'page_view', {
            page_title: document.title,
            page_location: window.location.href,
            page_path: window.location.pathname,
            send_to: 'UA-23176427-1'
        });
    }

    switch(name) {
        case 'about':
            // code block
            page.control.bg.fadeColor(0.1, time);
            break;
        case 'contacts':
            page.control.bg.fadeColor(0.3, time);
            break;
        case 'market':
            page.control.bg.fadeColor(0.3, time);
            break;
        case 'buying':
            page.control.bg.fadeColor(0.9, time);
            break;
        case 'buying_eko':
            page.control.bg.fadeColor(0.9, time);
            break;
        case 'buying_points':
            page.control.bg.fadeColor(0.9, time);
            break;
        case 'buying_cultures':
            page.control.bg.fadeColor(0.9, time);
            break;
        case 'region-representation':
            page.control.bg.fadeColor(0.9, time);
            break;
        case 'news':
            page.control.bg.fadeColor(0.3, time);
            break;
        default:
            page.control.bg.fadeColor(0.1, 300);
        break;
    }
};

page.main.init = function(){
    log.page("> INIT: MAIN");
    var f=page.main.f;
    var v=page.main.v;

    page.main.fr.stupidMenu.checkScrolled();


    var vh = window.innerHeight * 0.01; // Then we set the value in the --vh custom property to the root of the document

    document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));

    f.inlineSVG();

    f.initHiddenMenu();
    f.changeMenuInit();
    $('.same-height').matchHeight();
    f.fixedBurger();
    v.mobileScrolled = false;

  /*  $('body').unbind("touchmove").bind('touchmove', function(e) {
        if(!v.mobileScrolled){
            $('.market-explain').addClass('show');
        }
    });

    $(document).on('touchmove','.altMark-container',  function(){
        if( $(this).scrollLeft() > 0) {
            $('.market-explain').removeClass('show');
            v.mobileScrolled = true;
        }
    });*/


    if($(window).width() < 1024 && $('.section-slide').length > 0){
        f.setScreenHeight();
    }

    $('.cookie-agree').click(function(e){
        e.preventDefault();
        setCookie('_allowcookies', 1 , 30);
        $('.footer-gdpr').removeClass('active');
    });

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires="+d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    if(getCookie('_allowcookies') != 1){
        $('.footer-gdpr').addClass('active');
    }

    $(document).on('click','.scroll-top',function(e){
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 800);
    });

    page.main.resize();

    setTimeout(function(){
        page.quality = 3;
    },300);

    $('#popup_mic_trigger').fancybox({
        afterShow: function(){
            setCookie('nopopup2_'+$('html').attr('lang'), 1, 1);
        }
    });

   /* $('#popup_misc').fancybox({
        afterShow: function(){
            setCookie('nopopup2_'+$('html').attr('lang'), 1, 1);
        }
    });*/

    page.main.fr.cvUpload.init()

};

page.main.f = {
    inlineSVG : function() {
        /*
         * Replace all SVG images with inline SVG
         */
        jQuery('img.svg').each(function () {
            var $img = jQuery(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            jQuery.get(imgURL, function (data) {
                // Get the SVG tag, ignore the rest
                var $svg = jQuery(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
                if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                    $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
                }

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');

        });
    },

    checkSlides : function(){
        if($('.section-slide').length > 0){return true;}
        return false;
    },

    floatLable : function() {
        var $floatInput = $('.label-float input');

        $floatInput.focusin(
                function () {
                    $(this).parent().addClass('label-floating');
                })
            .focusout(function () {
                if ($(this).val() == '') {
                    $(this).parent().removeClass('label-floating');
                }
            });
        $floatInput.keydown(function (e) {
            if ($(this).val() !== '') {
                $(this).parent().addClass('label-floating');
            } else {
                if (!$(this).is(":focus")) {
                    $(this).parent().removeClass('label-floating');
                }
            }
        });

    },

    formsSubmit : function() {
        $('.form').off('submit').submit(function (e) {
            e.preventDefault();
            // todo ajax
        })
    },

    initContMap: function() {
       /* var $tooltip = $('.map-tooltip');
        if ($tooltip.length == 0) {
            return false;
        }
        var $bounding = $('.contact-map')[0].getBoundingClientRect();
        var $point = $('.map-point-1')[0].getBoundingClientRect();

        var top = $point.top - $bounding.top - $tooltip.height() - 40;
        var left = $point.left - $bounding.left - $tooltip.width() / 2 + 5;


        $tooltip.addClass('active').css({
            top: top,
            left: left
        });*/
    },

    changeMenuInit: function() {
        $('.toggle-menu').off('click').click(function (e) {
            e.preventDefault();
            var $bg = $('.mobile-menu--bg');
            var $menu = $('.mobile-menu');
            if ($bg.hasClass('active')) {
                page.main.v.menuT2.reverse();
                $bg.removeClass('active');
            } else {
                page.main.v.menuT2.play();
                $bg.addClass('active');
            }
            $menu.toggleClass('active');
        })
    },

    initHiddenMenu: function(){
        $('.mobile-menu--bg, .mobile-menu').addClass('loaded');
    },

    scrolledLogo: function(){
        if($('.header').hasClass('header--full')){
            return false;
        }
        if($(window).width() > 1006 && $('.fixed-slide').length == 0) {

            if ($(window).scrollTop() <= 2) {
                $('.header-logo').removeClass('scrolled');
            } else {
                $('.header-logo').addClass('scrolled');
            }
        }
        if ($(window).scrollTop() <= 2) {
            $('.burger').removeClass('scrolled');
        } else {
            $('.burger').addClass('scrolled');
        }
    },

    controlerInit: function() {
        /* page.main.v.controller = new ScrollMagic.Controller();

        var scene = new ScrollMagic.Scene({
                triggerElement: "footer",
                triggerHook: 1,
                duration: 0,
                offset: -10
            })
            .setPin(".scrollOut", {
                pushFollowers: true
            })
            .addTo(page.main.v.controller);*/
    },

    fixedBurger: function(){
        var $burger = $('.burger');
        if($(window).width() < 600){
            $('body').on( 'DOMMouseScroll mousewheel touchmove', function ( event ) {
                if( event.originalEvent.detail > 0 || event.originalEvent.wheelDelta < 0 ) { //alternative options for wheelData: wheelDeltaX & wheelDeltaY
                    $burger.addClass('hide');
                } else {
                    $burger.removeClass('hide');
                }
            })
        }else{
            $burger.removeClass('hide');
        }
    },

    setScreenHeight: function(){
        $('.section-slide, .section-slide--inner').css('height', $(window).height());
        page.main.v.wWidth = $(window).width();
    },

    loadNext: function(){
        log.page("STATE: Next");
        page.state = page.list[page.main.v.nextPage];
        page.main.v.nextPage = "";
        page.state.load();
    },

    changeMenuClass: function(page){

        if(page == 'homepage'){
            $('.header')
                .removeClass('header--alt')
                .addClass('header--full');
            $('footer')
                .removeClass('footer-default')
              //  .addClass('footer-alt')
               // .addClass('section-slide');
        }
        if(page != 'homepage'){

            $('.header')
                .removeClass('header--full')
                .addClass('header--alt');
            $('footer')
                .removeClass('footer-alt')
                .removeClass('section-slide')
                .addClass('footer-default');
        }

    }

};

page.main.fr = {
    reps: [],
    countClicks: function(){
        $.ajax({
            data: { action: 'countClicks'},
            type: 'post',
            url: ajaxurl,
            success: function (data) {
            }
        })
    },
    tableChange: {
        init: function(){
            $(document).on('click', '.market-table-switch--inner',function(e){
                e.preventDefault();

                $('.market-table-switch--trigger').toggleClass('reverse');
                $('.altMark').toggleClass('alt');

            });

        },
        destroy: function(){
            $(document).off('click', '.market-table-switch--inner');
        }
    },
    newsletter: {
        init: function(){
            $('.form.form-newsletter').submit(function (e) {
                e.preventDefault();
                let $this = $(this);
                let $msg = $('.form-message');
                $msg
                  /*  .slideUp()*/
                    .removeClass('errors');
                $.ajax({
                    data: $this.serialize(),
                    type: 'post',
                    url: ajaxurl,
                    success: function (data) {
                        let  response = JSON.parse(data);
                        $('.checkbox, .label-float').removeClass('error');

                        if (response.status == '0') {
                            $.each(response.errors, function(id, text){

                                let $inputParent = $('#'+id).parent();

                                $inputParent.find('.field-error').html(text);
                                $inputParent.addClass('error');


                            });
                           // $msg.slideDown();
                        }
                        if (response.status == '1') {

                            let $rows = $this.find('.row');
                            TweenMax.staggerTo($rows, 0.2, {
                                autoAlpha: 0,
                                onComplete:function(){
                                    setTimeout(function(){
                                        $msg
                                            .html('<h3>'+response.success+'</h3>')
                                            .css({
                                                visibility:'visible',
                                                opacity: 0,
                                            })
                                            .show()
                                            .addClass('success');
                                        TweenMax.to($msg,0.2, {autoAlpha: 1});
                                    }, 300)
                            }}, 0.2);
                        }
                    }
                });
            });
        },
        destroy: function(){
            $('.form.form-newsletter').off();
        }
    },
    socialLinks: {
        init:function(){
            $('.social-links').on('click', '.expand', function(e){
                e.preventDefault();
                var $this  = $(this);
                var $next = $this.next();
                var $target = $this.data('target');

                $('.social-content').removeClass('active');
                $('.'+$target).addClass('active');
                $('.expand').removeClass('active');
                $('.pg-link').removeClass('active');

                $this.addClass('active');
                if($next.hasClass('social-links-list')){
                    if($next.hasClass('slided')){
                        $next
                            .slideUp()
                            .removeClass('slided');
                        $this.removeClass('active');
                    }else {
                        $('.social-links-list').each(function(){
                            if($(this).hasClass('slided')){
                                $(this)
                                    .slideUp()
                                    .removeClass('slided');
                            }
                        });
                        $next
                            .slideDown()
                            .addClass('slided')
                            .find('.pg-link')
                            .first()
                            .addClass('active')
                            .trigger('click');
                    }
                }
            });
            $('.social-links-list').on('click','.pg-link', function(e){
                e.preventDefault();
                var $this = $(this);
                var $target = $this.data('target');
                $('.pg-link').removeClass('active');
                $('.social-logos').removeClass('active');
                $this.addClass('active');
                $('.'+$target).addClass('active');
            });
        },
        destroy:function(){
            $('.social-links, .social-links-list').off();
        }
    },
    cultureLinks: {
        init: function(){

           $('.culture-list .expand').click(function(e){
                e.preventDefault();
                let $this = $(this);
                let $next = $this.next();

                if($this.hasClass('active') && $next.hasClass('culture-child-list')){
                    $next.slideToggle();
                    //$this.removeClass('active');
                    return false;
                }
                if(!$this.hasClass('active')){
                    $('.expand').removeClass('active');
                    $this.addClass('active');
                    if($next.hasClass('culture-child-list')){
                        $('.slided')
                            .removeClass('slided')
                            .slideUp();
                        $next
                            .slideDown()
                            .addClass('slided');
                    }else{
                        $('.culture-child-list')
                            .slideUp()
                            .removeClass('slided');
                    }
                }
                if($this.hasClass('empty')){
                    $next.find('.pg-link').first().trigger('click');
                }
                if(!$this.hasClass('empty')){
                    $('.culture-content-txt').hide();
                    $($this.data('target')).show();
                }
                

            });
            $('.culture-child-list .pg-link').click(function(e){
                e.preventDefault();
                let $this = $(this);
                $('.pg-link').removeClass('active');
                $this.addClass('active');
                let target = $this.data('target');
                $('.culture-content-txt').hide();
                $('.requirements-extra').slideUp();
                $(target).show();
            });

            let hash = window.location.hash;

            if(hash){

                $('a[data-target="'+hash+'"').trigger('click');
                $('.expand').removeClass('active');
                let $target = $('a[href="'+hash+'"]');
                $target.trigger('click');
                if($target.hasClass('pg-link')){
                    $target.parent().parent().parent().slideDown().prev().addClass('active');
                }
            }
        },
        destroy: function(){
            $('.culture-list .expand, .culture-child-list .pg-link').off();
        }
    },
    floatLabels: {
        init:function(){
            let $floatInput = $('.label-float input');
            $floatInput
                .focusin(function () {
                    $(this).parent().addClass('label-floating');
                })
                .focusout(function () {
                    if ($(this).val() == '') {
                        $(this).parent().removeClass('label-floating');
                    }
                })
                .keydown(function (e) {
                    if ($(this).val() !== '') {
                        $(this).parent().addClass('label-floating');
                    } else {
                        if (!$(this).is(":focus")) {
                            $(this).parent().removeClass('label-floating');
                        }
                    }
                });

        /*    $('.file-input').on('click', function(e){
                let $this = $(this);
          //      $('#filename-'+$this.attr('name')).val('');
                console.log(e.target.files);
            })
*/

            $('.file-input')
                .change(function (e) {
                    if ($(this).attr('type') == 'text') {
                        return false;
                    }
                    let $this = $(this);
                    if( e.target.files.length) {
                        $this.parent().addClass('label-floating');
                        let filename = e.target.files[0].name;
                        $('#filename-' + $this.attr('name')).val(filename);
                    }else{
                        $this.parent().removeClass('label-floating');
                        $('#filename-' + $this.attr('name')).val('');

                    }
                });

         /*   $('.file-input').on('focusout', function(e){
                console.log(e.target.files);
            })
*/
            /* $('.filename-holder').focusin(function(e){
                console.log('Focused with tab move');
                let trigger = $(this).attr('id').replace('filename', 'input');
                console.log(trigger);
                $('#'+trigger).trigger('click');
            })*/

        },
        destroy: function(){
            $('.label-float input, #input-2').off('focusin', 'focusout', 'keydown');
        }
    },
    getManagers: function(){

        if(page.main.fr.reps.length > 0){

            page.main.fr.managerMap.init(page.main.fr.reps);
            return;
        }

        $.ajax({
            data: {action: 'get_managers'},
            type: 'post',
            url: ajaxurl,
            success: function(data) {
                page.main.fr.reps = JSON.parse(data);
                page.main.fr.managerMap.init(page.main.fr.reps)
            }
        });
    },
    managerMap: {
        init: function(reps){
            if(typeof reps === 'undefined'){}

            page.main.fr.managerMap.reset();

            $('.rep-info--close').click(function(e){
                e.preventDefault();
              //  $('.map-tooltip').addClass('active');

                $('.dropdown-manager').val(0).trigger('change.select2');
                $('.dropdown-region').val(0).trigger('change.select2');

                $('.rep-info').removeClass('active');
                $('.map-zone').removeClass('active');
            });

            $('.map-zone .map-point-hover').mouseenter(function(e){


            }).mouseleave(function(e){

                $('.map-tooltip').removeClass('active');

            }).click(function(e){

                $('.burger').addClass('hide');
                $('.map-tooltip').removeClass('active');
                let $tooltip = $('.rep-info');
                let $repId = $(this).data('rep');

                let $img = $('.rep-info--avatar');
                let $regions = $('.rep-regions--list');
                let $name = $('.rep-info--name');
                let $cont = $('.rep-info--contacts');

                let cRep = reps[$repId];

                console.log(cRep);

                $img.html("<img src='"+cRep['img']+"'>");

                let _regions  = JSON.parse(cRep['regions']);

                let _holders = {
                    left : [],
                    right : []
                }

                if(_regions.length > 8){
                    for(let i=0 ; i < _regions.length ; i++){
                        if( i < _regions.length/2) {
                            _holders['left'].push(_regions[i]);
                        }else{
                            _holders['right'].push(_regions[i]);
                        }
                    }

                    $('.rep-info').addClass('extended');


                    $regions.addClass('double').html('<div><p>'+_holders['left'].join('<br>')+'</p></div>'+'<div><p>'+_holders['right'].join('<br>')+'</p></div>');

                }else{
                    $('.rep-info').removeClass('extended');
                    $regions.removeClass('double').html('<p>'+JSON.parse(cRep['regions']).join('<br>')+'</p>');
                }


                $name.html(cRep['name']);
                $cont.html(cRep['tel']);

                let contacts = '<p>';

                let _tels = JSON.parse(cRep['tel']);
                $.each(_tels, function(){
                    contacts += '<a href="tel:'+this+'">'+this+'</a><br>' ;
                });
                let _emails = JSON.parse(cRep['email']);
                $.each(_emails, function(){
                    contacts += '<a href="mailto:'+this+'">'+this+'</a><br>';
                });
                contacts += '</p>';
                $cont.html(contacts);
                //   inlineSVG();

                if(page.checklist.CONTACTS.scene !== null){
                    page.checklist.CONTACTS.scene.duration($tooltip.outerHeight());
                }
                if(!$tooltip.hasClass('active')){
                    setTimeout(function(){
                        $tooltip.addClass('active');
                    }), 300
                }/*
                $tooltip.addClass('active');*/

            })


            $('.section').click(function(e){
                if($(e.target).parents('.rep-info').length > 0 || e.target.id == 'contacts-map' || $(e.target).parents('#contacts-map').length > 0){
                    return false;
                }
                $('.rep-info--close').trigger('click');

               // $('.rep-info').removeClass('active');
            })
        },
        reset: function(){

         /*   let $tooltip = $('.map-tooltip');
            if ($tooltip.length == 0) {
                return false;
            }
            let $bounding = $('.contact-map')[0].getBoundingClientRect();
            let $point = $('.map-point-1')[0].getBoundingClientRect();

            let top = $point.top - $bounding.top - $tooltip.height() - 40;
            let left = $point.left - $bounding.left - $tooltip.width() / 2 + 5;

            $tooltip.addClass('active').css({
                top: top,
                left: left
            });*/
        },
        destroy: function(){
            $('#regionų_atstovai').off();
            $('.map-zone .map-point-hover , .rep-info--close').off();
        }
    },
    cvUpload: {
        init: function(){

            $('.file-upload').click(function(e){
             //   let $this = $(this);
             //   let target = $this.data('target');
               // $('#'+target).trigger('click');
               // console.log(target);

            });

            $('.form.form-file')
                .off('submit')
                .submit(function (e) {
                    e.preventDefault();
                    let form = $(this);
                    let formdata = (window.FormData) ? new FormData(form[0]) : null;
                    let $msg = $('.form-message');
                    let $this = $(this);
                    let data = (formdata !== null) ? formdata : form.serialize();
                    formdata.append("action", "cv_registration");
                    $this.find('.label-floating').removeClass('error');
                    $this.find('.checkbox').removeClass('error');
                    $.ajax({
                        type: 'POST',
                        url: ajaxurl,
                        contentType: false,
                        processData: false,
                        dataType: 'JSON',
                        status: 200,
                        data: formdata,
                        success: function (data) {
                        //    console.log(data);

                            let response = data;
                            if(response.status == 0){

                           //     console.log(response.errors);
                                $.each(response.errors, function(id, text){
                                    // $msg.append('<p>'+text+'</p>');
                                    let $inputParent = $('#'+id).parent();
                                    if($inputParent.length == 0){
                                        $inputParent = $('#input-'+id).parent();
                                    }

                                    $inputParent.find('.field-error').html(text);
                                    $inputParent.addClass('error');
                                });
                            }
                            if(response.status == '1'){
                                let $rows = $this.find('.row');
                                TweenMax.staggerTo($rows, 0.2, {
                                    autoAlpha: 0,
                                    onComplete:function(){
                                        setTimeout(function(){
                                            $msg
                                                .html('<h3>'+data.success+'</h3>')
                                                .css({
                                                    visibility:'visible',
                                                    opacity: 0,
                                                })
                                                .show()
                                                .addClass('success');
                                            TweenMax.to($msg,0.2, {autoAlpha: 1});
                                        }, 300)
                                    }}, 0.2);
                            }
                        }
                    });
                });
        },
        destroy: function(){
            $('.form.form-newsletter, .file-upload').off();
        }

    },
    tableExpand: {
        table: '',
        repsTable: [],
        init: function(){
            $('.altMark-Main').click(function(e){
                let $this = $(this);
                let container = $this.data('target');
                let item =   $('[data-container="'+container+'"]');

                if(item.hasClass('active')){
                    item.slideUp(function(){
                        item.removeClass('active');
                    });

                }else{
                    item.addClass('active').slideDown();
                }

                $this.toggleClass("active");
            });

            $('.market-table--main').click(function(e){
                if($(this).hasClass('market-table--currency')){ return false;};
            });

        },
        destroy: function(){
            $('.altMark-Main, .market-table--main').off();
        },

        ajax: function(){

            $.ajax({
                data: { action : 'get_stock_content_ajax' },
                type: 'post',
                url: ajaxurl,
                success: function (data) {

                }
            }).done(function(data){
                page.main.fr.repsTable = JSON.parse(data);
                page.main.fr.tableExpand.setUpTable( page.main.fr.repsTable);
            });
        }
    },
    initSelect: function(){
        $('.js-dropdown').select2({
            language: "lt",
            templateResult: formatItem
        });
        function formatItem (state) {
            if (!state.id) { return state.text; }
            var $state = $(
                '<span class="' + state.element.className + '">' + state.text + '</span>'
            );
            return $state;
        }
        console.log('init dropdown');
    },
    buyingPoints: {
        points : [],
        manager : [],
        userPos : null,
        closes : [],
        distances: [],
        geocoder: null,
        autoComplete: null,
        ajax: function(){
            $.ajax({
                data: {action: 'get_points'},
                type: 'post',
                url: ajaxurl,
                success: function (data) {
                    let response = JSON.parse(data);
                    page.main.fr.buyingPoints.points = response.points;
                    page.main.fr.buyingPoints.manager = response.managers;
                    page.main.fr.buyingPoints.init(page.main.fr.buyingPoints.points, page.main.fr.buyingPoints.manager);
                }
            });
        },
        init: function(points, manager){

            page.main.fr.initSelect();

            let markerPoints = [];
            let infoWindows = [];

            let currentpos = null;

            let distanceWindow = null;

            let map,
                bounds,
                directionsService,
                directionsDisplay;

            let ico_w = 46;
            let ico_h = 46;
            let ico_x = 23;
            let ico_y = 23;

            let marker_hover =[];
            let marker_default = [];
            let markers_location = [];
            function initMap(region, type){

                marker_hover = {
                    url:stylesheet_directory_uri+'/wp-content/themes/agro/assets/svg/point_hover.svg',
                    size: new google.maps.Size(ico_w, ico_h),
                    anchor: new google.maps.Point(ico_x, ico_y)

                };

                marker_default = {
                    url:stylesheet_directory_uri+'/wp-content/themes/agro/assets/svg/point.svg',
                    size: new google.maps.Size(ico_w, ico_h),
                    anchor: new google.maps.Point(ico_x, ico_y)
                };

                markers_location = {
                    url:stylesheet_directory_uri+'/wp-content/themes/agro/assets/svg/point_loc.svg',
                        size: new google.maps.Size(ico_w, ico_h),
                        anchor: new google.maps.Point(ico_x, ico_y)
                };


                var gmap_marker = [];

                let zoom = 7;
                if($(window).width() < 600){
                    zoom = 6;
                }

                map = new google.maps.Map(document.getElementById('map'), {
                    center: {
                        lat: 55.2963775,
                        lng: 23.9258651
                    },
                    zoom: zoom,
                    panControl: false,
                    zoomControl: true,
                    mapTypeControl: false,
                    overviewMapControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    scrollwheel: false,
                    fullscreenControl: false,
                    gestureHandling: 'cooperative',

                    styles:
                        [
                            {
                                "featureType": "all",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "saturation": 36
                                    },
                                    {
                                        "color": "#333333"
                                    },
                                    {
                                        "lightness": 40
                                    }
                                ]
                            },
                            {
                                "featureType": "all",
                                "elementType": "labels.text.stroke",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    },
                                    {
                                        "color": "#ffffff"
                                    },
                                    {
                                        "lightness": 16
                                    }
                                ]
                            },
                            {
                                "featureType": "all",
                                "elementType": "labels.icon",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#9b4b4b"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "color": "#fefefe"
                                    },
                                    {
                                        "lightness": 20
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "color": "#fefefe"
                                    },
                                    {
                                        "lightness": 17
                                    },
                                    {
                                        "weight": 1.2
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "labels.text",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative",
                                "elementType": "labels.text.stroke",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative.country",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#256249"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative.country",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "visibility": "on"
                                    },
                                    {
                                        "invert_lightness": true
                                    },
                                    {
                                        "weight": "2"
                                    },
                                    {
                                        "color": "#eff2f9"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative.province",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#256249"
                                    }
                                ]
                            },
                            {
                                "featureType": "landscape",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "lightness": 20
                                    },
                                    {
                                        "color": "#00bf73"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "lightness": 21
                                    },
                                    {
                                        "color": "#00bf73"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "lightness": 21
                                    },
                                    {
                                        "color": "#13a286"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "labels.text",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi.park",
                                "elementType": "labels.text.stroke",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#00975b"
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "color": "#00975b"
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "lightness": 17
                                    },
                                    {
                                        "color": "#00975b"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "geometry.stroke",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    },
                                    {
                                        "lightness": 29
                                    },
                                    {
                                        "weight": 0.2
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "labels.text",
                                "stylers": [
                                    {
                                        "color": "#c04040"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.highway.controlled_access",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "color": "#00975b"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.arterial",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "lightness": 18
                                    },
                                    {
                                        "color": "#00975b"
                                    }
                                ]
                            },
                            {
                                "featureType": "road.local",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "lightness": 16
                                    },
                                    {
                                        "color": "#00975b"
                                    }
                                ]
                            },
                            {
                                "featureType": "transit",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "lightness": 19
                                    },
                                    {
                                        "color": "#00975b"
                                    }
                                ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "lightness": 17
                                    },
                                    {
                                        "visibility": "on"
                                    },
                                    {
                                        "color": "#243370"
                                    }
                                ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "labels.text.fill",
                                "stylers": [
                                    {
                                        "color": "#ffffff"
                                    }
                                ]
                            }
                        ]
                });

                page.main.fr.buyingPoints.geocoder =  new google.maps.Geocoder();
                bounds = new google.maps.LatLngBounds();

                $.each(points, function(i, marker) {


                    let mark = new google.maps.Marker({
                        position: {lat:parseFloat(marker.lat), lng: parseFloat(marker.lng)},
                        map: map,
                        icon: marker_default,
                        title : marker.region_title,
                    });
                    mark.regionId = marker.cityregion_id;

                    mark.buys = marker.buys;

                    mark.clicked = false;

                    let map_content = '';

                    map_content += '<div class="g-map-tooltip lt-aling">';
                    map_content += '<div class="g-map-tooltip--inner">';
                    //  map_content += '<a href="#" class="g-map-tooltip--arrow abs-left" data-point="'+i+'" data-region="'+marker.regionId+'"><span>žiūrėti<br>daugiau</span></a>';
                    map_content += '<div class="g-map-tooltip--content abs-right"><a href="#" class="close-gmap prevent"></a>';
                    map_content += '<div class="g-map-tooltip--buying">';

                    $.each(marker.culture, function(index, product){

                        map_content += '<span class="g-map-tooltip--products">'+product.post_title+',</span>';
                    });

                    map_content += '</div>';
                    map_content += '<div class="g-map-tooltip--title">'+marker.region_title+'</div>';
                    map_content += '<div class="g-map-tooltip--addr">'+marker.address_show+'</div>';

                    $.each(marker.tel, function(index, tel){
                        map_content += '<div class="g-map-tooltip--tel">'+tel+'</div>';
                    });

                    let   dest = marker.address_show;

                    let   url = 'https://www.google.com/maps/dir/?api=1&destination='+marker.lat+','+marker.lng ,//+dest.replace(/ /g, '+'),
                         svg_g = '<svg viewBox="0 0 533.5 544.3" xmlns="http://www.w3.org/2000/svg" style="width: 15px;margin-right: 6px;vertical-align: -4px;"><path d="M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z" fill="#4285f4"/><path d="M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3H28.9v70.1c46.2 91.9 140.3 149.9 243.2 149.9z" fill="#34a853"/><path d="M119.3 324.3c-11.4-33.8-11.4-70.4 0-104.2V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l90.4-70.1z" fill="#fbbc04"/><path d="M272.1 107.7c38.8-.6 76.3 14 104.4 40.8l77.7-77.7C405 24.6 339.7-.8 272.1 0 169.2 0 75.1 58 28.9 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z" fill="#ea4335"/></svg>',
                        svg_a = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 128.1 209.2" style="enable-background:new 0 0 128.1 209.2;" xml:space="preserve"><path style="fill:#fff" d="M0.6,0c42.5,35.1,85,70.1,127.5,105.2C85.4,139.9,42.7,174.6,0,209.2c0.1-11.8,0.1-23.6,0.2-35.4c27.2-22.8,54.4-45.7,81.5-68.5C54.5,81.7,27.4,58.1,0.3,34.5C0.4,23,0.5,11.5,0.6,0z"></path><path style="fill:#314787" d="M179.6,110.4"></path></svg>';
                    map_content += '<div style="display:flex; justify-content: center;">' +
                        '<a href="'+url+'" target="_blank" class="g-map-tooltip--arrow g-map-route abs-left prevent">'+svg_g+'<span>KAIP ATVYKTI</span></a>' +
                        '<a href="#" class="g-map-tooltip--arrow abs-left prevent g-map-tooltip--manager" data-point="'+marker.id+'" data-region="'+marker.cityregion_id+'">' +
                        '<span>žiūrėti daugiau</span>' +svg_a+
                        '</a></div><div class="g-map-tooltip--extrainfo"></div>';


                    map_content += '</div>';

                    google.maps.InfoWindow.prototype.opened = false;
                    let infoWindow = new google.maps.InfoWindow({
                        content: map_content
                    });

                    markerPoints.push(mark);
                    infoWindows.push(infoWindow);

                    google.maps.event.addListener(mark, 'mouseover', function() {
                        this.setIcon(marker_hover);
                    });

                    google.maps.event.addListener(mark, 'mouseout', function() {
                        if(!this.clicked){
                            this.setIcon(marker_default);
                        }
                    });

                    google.maps.event.addListener(mark, 'click', function(cont) {

                        closeInfoWindows();
                        $('.g-map-managers').removeClass('active');

                        $('.location-popup').slideUp();

                        $.each(markerPoints, function(){
                            this.setIcon(marker_default);
                            this.clicked = false;

                        });

                        mark.setIcon(marker_hover);

                        mark.clicked = true;

                        if(page.main.fr.buyingPoints.userPos !== null && typeof cont == 'object'){
                            caclRoute(page.main.fr.buyingPoints.userPos,this, i);
                        }

                        infoWindow.open(map,this);

                        if(typeof cont == 'string'){
                            $('.g-map-tooltip--extrainfo').html(cont);
                        }else{
                            $('.g-map-tooltip--extrainfo').html('');
                        }

                    });



                    closeInfoWindows();

                });

                directionsService = new google.maps.DirectionsService;
                directionsDisplay = new google.maps.DirectionsRenderer({
                    suppressMarkers: true,
                    preserveViewport: true,
                    polylineOptions: {
                        strokeColor: "#fff"
                    }
                });

                let input = document.getElementById('location-add');
                let autocomplete = new google.maps.places.Autocomplete(input);

                autocomplete.bindTo('bounds', map);

                autocomplete.addListener('place_changed', function() {

                    let place = autocomplete.getPlace();

                    if (!place.geometry) {
                        lookUpAdress();
                        return;
                    }
                    if (place.geometry){
                        geoOnSuccess(place.geometry.location.lat(),place.geometry.location.lng())
                    }
                });
            }

            function lookUpAdress(){
                let address = document.getElementById('location-add').value;
                let geo = page.main.fr.buyingPoints.geocoder;
                geo.geocode({'address': address}, function(results, status) {
                    if (status == 'OK') {
                        if(results.length > 0){
                            geoOnSuccess(results[0].geometry.location.lat(),results[0].geometry.location.lng());
                        }
                    } else {
                       // alert('Geocode was not successful for the following reason: ' + status);
                        alert('Įvestas adresas neteisingas arba neegzistuoja')
                    }
                });
            }

            function setMapOnRegion(region,type,map) {
                setMapOnAll(null);

                if(region == 0 && type == 0){
                    setMapOnAll(map);

                    closeInfoWindows();

                    $.each(markerPoints, function(){
                        this.setIcon(marker_default);
                        this.clicked = false;
                        $('.g-map-managers').removeClass('active');

                        setMapPointer(this,map);
                        expandBounds(this,bounds);
                    });
                    map.setZoom(7);
                    return;
                }

                var locations = 0;

                $.each(markerPoints, function(index , item){
                    let visible = false;
                    if(region != 0 && type != 0) {

                        if(item.regionId == region && item.buys.includes(parseInt(type))){
                            setMapPointer(item,map);
                            expandBounds(item,bounds);
                            locations++;
                            visible = true;
                        }

                    }
                    if(region == 0 && type != 0) {

                        if(item.buys.includes(parseInt(type))){
                            setMapPointer(item,map);
                            expandBounds(item,bounds);
                            locations++;
                            visible = true;
                        }

                    }
                    if(region != 0 && type == 0) {

                        if(item.regionId == region){
                            setMapPointer(item,map);
                            expandBounds(item,bounds);
                            locations++;
                            visible = true;
                        }
                    }

                    if(region == 0 && type == 0){
                        setMapOnAll(map);
                        visible = true;
                        return;
                    }
                    item.setVisible(visible);

                });

                if(locations == 0){
                    map.setZoom(7);
                }
                if(locations < 2){
                    map.setZoom(9);
                }

            }

            function closeInfoWindows(){
                $.each(infoWindows, function(){
                    this.close();
                });
            }

            function expandBounds(item,bounds){
                bounds.extend(new google.maps.LatLng(item.getPosition().lat(), item.getPosition().lng()));
                map.fitBounds(bounds);
            }

            function setMapPointer(item,map){
                item.setMap(map);
            }

            function setMapOnAll(map) {
                for (var i = 0; i < markerPoints.length; i++) {
                    markerPoints[i].setMap(map);
                }

            }

            $('.map-form').submit(function(e){
                e.preventDefault();
                let $this = $(this);
                let data = $this.serializeArray();

                let region = data[0]['value'];
                let type = data[1]['value'];

                let cultTool = $('.culture-tooltip');
                if(page.main.fr.buyingPoints.userPos !== null) {
                    directionsDisplay.set('directions', null);
                }
                if(type != 0) {

                    $.ajax({
                        data: {action: 'get_culture', id: data[1]['value']},
                        type: 'post',
                        url: ajaxurl,
                        success: function (data) {
                            cultTool.attr('href', data);
                            TweenMax.to(cultTool, 0.1, {autoAlpha:1});
                        }
                    });
                }else{
                    TweenMax.to(cultTool, 0.1,{autoAlpha: 0});
                }

                bounds = new google.maps.LatLngBounds();

                setMapOnRegion(region,type,map);


                if(region == 0 && type == 0){
                    $('.form-reset--holder').removeClass('active');
                }else{
                    $('.form-reset--holder').addClass('active');
                }
            });

            $('.form-reset').click(function(e){

                if(page.main.fr.buyingPoints.userPos !== null) {
                    page.main.fr.buyingPoints.userPos.setMap(null);
                    page.main.fr.buyingPoints.userPos = null;
                    directionsDisplay.set('directions', null);
                }

                $(".js-dropdown").val(0).trigger('change');
            });

            $(".js-dropdown").change(function(){
                $('.g-map-managers').removeClass('active');
                $('.map-form').submit();

                if($(window).width() < 1024) {

                    $([document.documentElement, document.body]).animate({
                        scrollTop: ($("#map").offset().top - 50)
                    }, 800);
                }
            });

            if($('#map').length){
                initMap();
            }

            $('.g-map-managers--close').click(function(e){
                e.preventDefault();
                $(this).parent().removeClass('active');
                TweenMax.set($('.header-logo').find('a'),{autoAlpha: 1});
                $.each(markerPoints, function(){
                    this.setIcon(marker_default);
                    this.clicked = false;
                });
            });

            $('#map').on('click','.g-map-tooltip--manager', function(e){
              //  if($(this).hasClass('.outgoing')){ return false;}
                e.preventDefault();

                let point = $(this).data('point');
                let regId = $(this).data('region');

                let url = window.location.href;
                if (url.indexOf('?') > -1){
                    let split = url.split('?');
                    url = split[0]+'?point='+point+'&regId='+regId;
                }else{
                    url += '?point='+point+'&regId='+regId
                }

                history.replaceState(null,null, url);

                closeInfoWindows();

                openManagerInfo(point, regId);
                /* if($(window).width() < 1024) {*/


                let $info =  $(".g-map-managers");
                let elOffset = $info.offset().top;
                let elHeight = $info.height();
                let windowHeight = $(window).height();
                let offset;


                if (elHeight < windowHeight) {
                    offset = elOffset - ( windowHeight - elHeight)/2  ;
                }
                else {
                    offset = elOffset;
                }

                let speed = 700;

                if($(window).width() < 560){
                    offset = $('.g-map-wrapper').offset().top;
                }
                $('html, body').animate({
                    scrollTop:offset
                }, speed);

            });

            $('#map').on('click','.close-gmap',function(e){
                e.preventDefault();
                closeInfoWindows();
                resetPinsStatus();
            });

            function resetPinsStatus(){
                console.log(markerPoints);
                for(let i = 0 ; i < markerPoints.length; i++){
                    markerPoints[i].clicked = false;
                    markerPoints[i].setIcon(marker_default);
                }
            }

            $(document).click(function(e){

                if($(e.target).parents('.g-map-managers').length == 0 ){
                    $('.g-map-managers').removeClass('active');
                }
            });

            function openManagerInfo(point,regionId){

                let $info = $('.g-map-managers');

                let pointer = [];

                $.each(points,function(key, value){

                    if(point == value.id){
                        let pointer = this;
                        let cultures = '';

                        $.ajax({
                            data: {action: 'get_cultures', data: pointer.buys},
                            type: 'post',
                            url: ajaxurl,
                            success: function (data) {

                                let cults = JSON.parse(data);

                                $.each(cults, function(){

                                    cultures += '<li><a href="'+this.url+'" class="ajax-barb">'+this.title+'</a> ';

                                    if(this.children.length > 0) {
                                        cultures += '(';
                                        let children = this.children;
                                        let length = children.length;

                                        $.each(children, function (index, item) {

                                            cultures += '<a href="'+item.url+'" class="ajax-barb">'+item.title.replace('klasė','')+'</a>';

                                            if(index !== length-1){
                                                cultures += ', ';
                                            }
                                        });
                                        cultures += ')';
                                    }

                                });

                                $('.g-map-managers--types').find('ul').html(cultures);

                                $info.addClass('active');
                            }
                        });


                        $('.g-map-managers--addr').html(pointer.address_show);
                        let   url = 'https://www.google.com/maps/dir/?api=1&destination='+pointer.lat+','+pointer.lng ;

                        $('.g-map-managers--addrGoogle').attr('href',url);


                        let tels = '';
                        $.each(pointer.tel,function(){
                            tels += '<a href="tel:'+this+'">'+this+'</a>  | ';
                        });

                        let emails = '';

                        $.each(pointer.emails, function(){

                            emails += '<a href="mailto:'+this+'">'+this+'</a>  | '
                        });
                      //  $('.g-map-managers--img').attr('src', pointer.manager['portrait']);


                        let mMang = '';
                        $.each(pointer.manager['tel'], function(){

                            mMang += '<a href="tel:'+this+'">'+this+'</a>';
                        });

                        let eMang = '';

                        $('.g-map-managers--name').html(pointer.manager['name']);
                        $('.g-map-managers--email').html('<a href="mailto:'+pointer.manager['email']+'">'+pointer.manager['email']+'</a>');
                        $('.g-map-managers--tel').html(mMang);

                        $('.g-map-managers--cont').html(tels+emails);
                        $('.g-map-managers--company').html(pointer.region_title);
                     //   $('.g-map-managers--img').attr('src', pointer.manager['potrait']);

                    }

                });

                managerPosition();

                if(page.checklist.CONTACTS.scene !== null){
                    page.checklist.CONTACTS.scene.duration($info.outerHeight());
                }


                // $info.addClass('active');
            }

            function managerPosition(){
                var $info = $('.g-map-managers');
                let winWidth = $(window).width();
                //$info.off();

                if(winWidth < 560 ){
                    $('.toggle-menu').addClass('hide');
                    $('.g-map-managers--close').click(function(e){
                        $('.toggle-menu').removeClass('hide');
                    })
                }

                if($info.length > 0){


                    let top =  $('#map').offset().top + $('#map').height()/2

                    $info.css({
                        'left': 0,
                        'top': top,
                        //'position' : 'fixed',
                    });
                }
            }

            function checkGet(){

                let get = getUrlVars();

                if(typeof get['point'] !== 'undefined' && typeof get['regId'] !== 'undefined'){
                    openManagerInfo(get['point'],get['regId']);
                    $.each(markerPoints, function(){
                        if(this.regionId == get['regId']){
                            $(this).clicked = true;
                            this.setIcon(marker_hover);
                        }

                    });

                }

            }

            function getUrlVars()
            {
                var vars = [], hash;
                var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
                for(var i = 0; i < hashes.length; i++)
                {
                    hash = hashes[i].split('=');
                    vars.push(hash[0]);
                    vars[hash[0]] = hash[1];
                }
                return vars;
            }

            checkGet();
            $(window).resize(function(e){

                if($('#map').length && $(window).width() > 800) {
                    page.main.fr.initSelect();
                }
            });

            // local

            $('.btn-location').click(function(e){
                e.preventDefault();

                closeInfoWindows();
                $('.location-popup').slideToggle()//.addClass("active");
            });

            $('.location-popup-detect').click(function(e){
                e.preventDefault();
                getLocation();
            });

            function getLocation() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(parseNavigator, geoOnError, {timeout:5000});
                } else {
                    alert('Geolocation is not supported by this browser.');
                }
            }

            function geoOnError(){

            }

            function parseNavigator(userCords){
               geoOnSuccess(userCords.coords.latitude,userCords.coords.longitude);
            }


            function geoOnSuccess(lat, lng){

                if(page.main.fr.buyingPoints.userPos !== null) {
                    page.main.fr.buyingPoints.userPos.setMap(null);
                    page.main.fr.buyingPoints.userPos = null;
                }


                currentpos = new google.maps.Marker({
                    position: {lat:parseFloat(lat), lng: parseFloat(lng)},
                    map: map,
                    icon: markers_location,
                    title : '', //todo title
                });
                page.main.fr.buyingPoints.userPos = currentpos;

                let distances = [];
                let holder = [];
                let found = true;
                for(let i = 0; i< markerPoints.length; i++){
                    if(markerPoints[i].visible) {
                        let d = google.maps.geometry.spherical
                            .computeDistanceBetween(
                                //    new google.maps.LatLng(parseFloat(markers[i].lat), parseFloat(markers[i].lng)),
                                new google.maps.LatLng(markerPoints[i].getPosition().lat(), markerPoints[i].getPosition().lng()),
                                new google.maps.LatLng(parseFloat(lat), parseFloat(lng)));

                        holder[i] = d;
                        distances.push(d);
                    }
                }
                let nMarkers = [];
                distances = distances.sort(function(a, b){return a - b});
                if(distances.length > 3){
                    nMarkers.push(holder.indexOf(distances[0]),holder.indexOf(distances[1]),holder.indexOf(distances[2]));
                }else if(distances.length == 0){
                    found = false;
                }else{
                    for(let i = 0; i < distances.length ; i ++){
                        nMarkers.push(holder.indexOf(distances[i]));
                    }
                }

                setMapOnAll(null);

                if(found) {
                    caclRoute(currentpos,markerPoints[nMarkers[0]], nMarkers[0]);
                    expandBounds( page.main.fr.buyingPoints.userPos ,bounds);
                    for (let i = 0; i < nMarkers.length; i++) {
                        setMapPointer(markerPoints[nMarkers[i]], map);
                        expandBounds(markerPoints[nMarkers[i]], bounds);
                    }
                    map.setCenter(page.main.fr.buyingPoints.userPos.getPosition());
                    //map.setZoom(map.getZoom() - 1);
                    //$('.location-popup').removeClass('active');
                    $('.location-popup').slideUp();
                    $('.form-reset--holder').addClass('active');
                }
            }

            function caclRoute(startMarker,endMarker,markerPos){

                let startPnt = new google.maps.LatLng(startMarker.position.lat(),startMarker.position.lng());
                let endPnt = new google.maps.LatLng(endMarker.position.lat(),endMarker.position.lng());

                let request = {
                    origin: startPnt,
                    destination: endPnt,
                    travelMode: google.maps.TravelMode.DRIVING,
                    provideRouteAlternatives: false,

                };

                directionsService.route(request, function (response, status) {

                    if (status == google.maps.DirectionsStatus.OK) {
                        directionsDisplay.setDirections(response);
                        directionsDisplay.setMap(map);

                        let cont =  '<div class="tooltip-distance">Atstumas: '+response.routes[0].legs[0].distance.text+'</div>' +
                            '<div class="tooltip-time">Trukmė: '+response.routes[0].legs[0].duration.text+'</div>'

                        $('.g-map-tooltip--extrainfo').html(cont);

                        new google.maps.event.trigger( endMarker, 'click', cont );
                    } else {
                        alert("Directions Request failed:" +status);
                    }
                });

            }



            $('.location-popup-add').submit(function(e){
               e.preventDefault();
                lookUpAdress();
            });

            $('.location-popup--close').click(function(e){
                e.preventDefault();
                $('.location-popup').slideUp()//removeClass('active');
            })
        },
        destroy: function(){
            $('.g-map-managers--close').off();
        }
    },
    popupLink: {
        init: function(){


            $('.popup-link').click(function(e){
                e.preventDefault();
                let $this = $(this);

                if($this.hasClass('scrollto')) {
                    let target = $($this.data('target')).parent();

                    $('html, body').animate({
                        scrollTop:$(target).offset().top - 20
                    }, 700);

                    return false;}
                $this.next().addClass('active');
            });
            $('.rek-info--close').click(function(e){
                e.preventDefault();
                $(this).parent().removeClass('active');
            })

            $(document).click(function(e){
                 if($(e.target).parents('.rek-info').length > 0 || $(e.target).hasClass('popup-link')){
                    return false;
                 }
                 $('.rek-info').removeClass('active');
            })

        },
        destroy: function(){
            $('.popup-link, .rek-info--close').off();
        }
    },
    toggleMenu: {
        init: function(){
            $('.toggle-menu').click(function(){
                e.preventDefault();
                var $bg = $('.mobile-menu--bg');
                var $menu = $('.mobile-menu');
                if($bg.hasClass('active')){
                    menuT2.reverse();
                    $bg.removeClass('active');
                }else{
                    menuT2.play();
                    $bg.addClass('active');
                }
                $menu.toggleClass('active');
            });

        }
    },
    infoPopup: {
        init: function(){
           // $('.question-icon').tooltipster({animation: 'fade', delay: 200});
            $('.info-hover--popup').click(function(e){
                e.preventDefault();
                let $this = $(this);
                let target = $this.data('target');
                $(target).addClass('active');
            });

            $('.info-popup--close').click(function(e){
                e.preventDefault();
                $('.info-popup').removeClass('active');
            });

            $(document).click(function(e){
                if($(e.target).parents('.info-popup').length > 0 || $(e.target).hasClass('info-hover--popup') || $(e.target).parents('.info-hover--popup').length > 0){
                    return false;
                }
                $('.info-popup').removeClass('active');
            })

        },
        destroy: function(){
            $('.info-hover--popup').off();
        }

    },
    setStickyMarker: {
        newArray: [],
        loadedArray:[],
        loadedArrayIndex: 0,
        changeTime: 9000,
        requiredMarkets:[
            'MATIF Milling Wheat',
            'MATIF Rapeseed'
        ],
        marketNames: {
            MATIF_Milling_Wheat: "Milling Wheat",
            MATIF_Rapeseed: "Rapeseed",
        },
        currencyNames: {
            EURUSDSP : "EUR/USD",
            USDRUBSP : "USD/RUB"
        },
        interval : null,
        active: false,
        setMarkets: function(items , array){
            $.each(items, function(index , item){
                array.push({
                    name: item.name,
                    last: item.last,
                    netCng: item.netCng,
                    status: item.netCngStatus,
                    equil: item.netCngEquil,
                    unit: 'EUR',
                    active: 0
                });

            });
        },
        setCurrencies: function(items ,array){
            let stickyMarket = page.main.fr.setStickyMarker;
            if(items.lentgh > 0) {
                $.each(items, function (index, item) {
                    let quote = item.quote;
                    let termArray = quote.split('/');
                    let term = termArray[termArray.length - 1];
                    let name = stickyMarket.currencyNames[term];
                    let value = stickyMarket.currencyNames[term].split('/');
                    array.push({
                        name: name,
                        last: item.last,
                        netCng: item.netCng,
                        status: item.netCngStatus,
                        equil: item.netCngEquil,
                        unit: value[1],
                        active: 0
                    });
                });
               // page.main.v.marketSticky.play(0);
            }else{
               // page.main.v.marketSticky.reverse();
            }

        },
        init: function(array, update){
            let stickyMarket = page.main.fr.setStickyMarker;
            let $container = $('.sticky-market--contain');


            if(!update){

                let initMarkets = [];
                let initCurrency = [];
                $.each(array.market , function(index, item){

                    initMarkets.push(stickyMarket.initSort(item,'market'));
                });
                $.each(array.currency, function(index,item){
                    initCurrency.push(stickyMarket.initSort(item, 'currency'));
                });
                stickyMarket.setMarkets(initMarkets, stickyMarket.loadedArray);
                stickyMarket.setCurrencies( initCurrency, stickyMarket.loadedArray);
                initMarkets = null;
                initCurrency = null;

                $.each(stickyMarket.loadedArray, function(index, item){
                    item.active = 0;
                    if(index === stickyMarket.loadedArrayIndex){
                        changeContent(item);
                    }
                });
                stickyMarket.loadedArrayIndex++;
                if(stickyMarket.loadedArrayIndex > stickyMarket.loadedArray.length - 1){
                    stickyMarket.loadedArrayIndex = 0;
                }

            }

            function changeContent(item){

                let className = '';
                switch(item.status){
                    case('up'):
                        className = 'triangle-up';
                        break;
                    case('down'):
                        className = 'triangle-down';
                        break;
                }
                let dirClass = '';

                if(Number(item.netCng) > 0){
                    dirClass = 'val-positive';
                }

                if(Number(item.netCng) < 0){
                    dirClass = 'val-negative';
                }

                let txt = '<span style="visibility: hidden;opacity: 0;">'+item.name+'</span>';
                txt += '<span style="visibility: hidden;opacity: 0;">'+item.last+' '+item.unit+'</span>';
                txt += '<span style="visibility: hidden;opacity: 0;" class="'+dirClass+'">'+item.netCng+'</span>';

                TweenMax.staggerTo(
                    $container.find('span'), 0.42, {autoAlpha:0},0.15, allComplete);
                function allComplete(){
                    $container
                        .html(txt)
                        .css({height: 'auto'})
                        .height($container.outerHeight());

                    TweenMax.staggerTo(
                        $container.find('span'),0.42,{autoAlpha: 1}, 0.15);
                }
                item.active = 1;
            }


            $(window).on('resize', function(){
                $container.css({height: 'auto'});
            });

            if(update){
                clearTimeout(stickyMarket.interval);



            }

            stickyMarket.interval =  setInterval(function(){
                $.each(stickyMarket.loadedArray, function(index, item){
                    item.active = 0;
                    if(index === stickyMarket.loadedArrayIndex){
                        changeContent(item);
                    }
                });
                stickyMarket.loadedArrayIndex++;
                if(stickyMarket.loadedArrayIndex > stickyMarket.loadedArray.length - 1){
                    stickyMarket.loadedArrayIndex = 0;
                }
            },stickyMarket.changeTime);

        },
        initSort: function(array, type){
            switch(type){
                case('market'):

                    let newObj = {};
                    newObj.name = array.name;
                    newObj.code = array.code;
                    newObj.last = array.price.last.value;

                    newObj.netCng = array.price.stats.perf;
                    newObj.netCngStatus = array.price.stats.statusPerf;
                    newObj.netCngEquil = array.price.stats.statusPerfEquil;

                    newObj.netCngp = array.price.stats.relPerf;
                    newObj.netCngpStatus = array.price.stats.statusPerfPercent;
                    newObj.netCngpEquil = array.price.stats.statusPerfPercentEquil;

                    newObj.bid = array.price.bid.value;
                    newObj.bidStatus = array.price.bid.statusValue;
                    newObj.bidEquil = array.price.bid.statusValueEquil;

                    newObj.bidSize = array.price.bid.volume;
                    newObj.bidSizeStatus = array.price.bid.statusVolume;
                    newObj.bidSizeEquil = array.price.bid.statusVolumeEquil;

                    newObj.ask = array.price.ask.value;
                    newObj.askStatus = array.price.ask.statusValue;
                    newObj.askEquil = array.price.ask.statusValueEquil;

                    newObj.askSize = array.price.ask.volume;
                    newObj.askSizeStatus = array.price.ask.statusVolume;
                    newObj.askSizeEquil = array.price.ask.statusVolumeEquil;

                    newObj.settl = array.settlementPrice;
                    newObj.settlStatus = array.settlementPriceStatus;
                    newObj.settlEquil = array.settlementPriceEquil;

                    newObj.high = array.price.high.value;
                    newObj.highStatus = array.price.high.statusValue;
                    newObj.highEquil = array.price.high.statusValueEquil;

                    newObj.low = array.price.low.value;
                    newObj.lowStatus = array.price.low.statusValue;
                    newObj.lowEquil = array.price.low.statusValueEquil;
                    return newObj;
                    break;
                case('currency'):
                    let newCur = {};
                    newCur.last = array.last.value;

                    newCur.netCng = array.stats.perf;
                    newCur.netCngStatus = array.stats.statusPerf;
                    newCur.netCngEquil = array.stats.statusPerfEquil;


                    newCur.netCngp = array.stats.relPerf;
                    newCur.netCngpStatus = array.stats.statusPerfPercent;
                    newCur.netCngpEquil = array.stats.statusPerfPercentEquil;

                    newCur.bid = array.bid.value;

                    newCur.ask = array.ask.value;

                    newCur.settl = array.settlement.value;
                    newCur.settlStatus = array.settlement.settlementPriceStatus;
                    newCur.settlEquil = array.settlement.settlementPriceEquil;


                    newCur.high = array.high.value;

                    newCur.low = array.low.value;

                    newCur.quote = array.quote;

                    return newCur;
                    break;
            }
        },
        update: function(){
            let stickyMarket = page.main.fr.setStickyMarker;
            let oldArray = stickyMarket.loadedArray;
            let newArray = stickyMarket.newArray;
            $.each(newArray, function(index , item){
                $.each(oldArray,function(index, oldItem){
                    if(item.name === oldItem.name){
                        if(item.change < oldItem.change){
                            item.status = 'down';
                        }
                        if(item.change > oldItem.change){
                            item.status = 'up';
                        }
                        if(item.change === oldItem.change){
                            item.status = 'none';
                        }
                    }
                })
            });
            stickyStart = {};
            stickyMarket.loadedArray = newArray;
            stickyMarket.newArray = {};
        }
    },
    tooltipster: {
        init: function(){
            $('.question-icon').tooltipster({
                animation: 'fade',
                delay: 200,
                trigger:"custom",
                triggerOpen: {
                    mouseenter: true,
                    click: true,  // For mouse
                    tap: true    // For touch device
                },
                triggerClose: {
                    mouseleave: true,
                    click: true,  // For mouse
                    tap: true    // For touch device
                }
            });

        },
        destroy: function(){
            $('.info-hover').off();
        }
    },
    magicScroll: {
        controller: null,
        scene: null,
        init: function(){

            if(page.main.fr.magicScroll.controller !== null){
                console.error("controller already exists");
            }

            page.main.fr.magicScroll.controller = new ScrollMagic.Controller();
         //   page.main.fr.magicScroll.sceneInit();
        },
        sceneInit: function(){
            let magicScroll = page.main.fr.magicScroll;
            if(magicScroll.scene !== null){
           //     console.error("Scene already exists");
            }

            magicScroll.scene = new ScrollMagic.Scene({
                    triggerElement: "footer",
                    triggerHook: 1,
                    duration: 0,
                    offset: -10
                })
                .setPin(".scrollOut", {pushFollowers: true})
                .addTo(magicScroll.controller);
        },
        reset : function(){
        },
        destroy:function(){
        }
    },
    stupidMenu: {
        isAnimating: false,
        scrolledState: false,
        showLogo: null,
        showMenu: null,
        showBurger: null,
        menuStatus: false,
        burgerStatus: true,
        checkScrolled: function(){
            if($(window).scrollTop() > 2){
              return page.main.fr.stupidMenu.scrolledState = true;
            }
            return page.main.fr.stupidMenu.scrolledState = false;

        },
        setLogoTimeline: function(){
            let menu = page.main.fr.stupidMenu;
            menu.showLogo = new TimelineMax({paused: true});
            menu.showLogo
                .to('.header-logo',0.2,{autoAlpha: 1});
        },
        setMenuTimeline: function(){
            let menu = page.main.fr.stupidMenu;
            menu.showMenu = new TimelineMax({paused: true, onComplete(){
            },onReverseComplete(){
                    menu.showBurger.play();
            }});
                menu.showMenu
                    .staggerTo('.stagger', 0.2, {autoAlpha: 1}, -0.1);
        },
        setBurgerTimeline: function(){
            let menu = page.main.fr.stupidMenu;
            menu.showBurger = new TimelineMax({paused:true , onComplete(){
            },onReverseComplete(){
                menu.showMenu.play();
            }});
            menu.showBurger
                .to('.burger', 0.1, {autoAlpha: 1, scale: 1, onComplete(){},onReverseComplete(){}});
        },
        init: function(){
            let menu = page.main.fr.stupidMenu;
            menu.setLogoTimeline();

            if(menu.showLogo !== null ){
                menu.showLogo.play();
            }
            let barb = $('.barba-container').data('namespace');

            menu.setMenuTimeline();

            if(menu.showMenu !== null && menu.scrolledState !== true || barb == 'homepage' ){
                menu.showMenu.play();
            }
            menu.setBurgerTimeline();
            if(menu.showBurger !== null && menu.scrolledState === true &&  barb != 'homepage'){
                menu.showBurger.play();
            }
        },
        scroll: function(){
            let menu = page.main.fr.stupidMenu;
            let barb = $('.barba-container').data('namespace');

            if(menu.scrolledState && menu.burgerStatus && barb !== 'homepage'){
                menu.showMenu.reverse();
            }
            if(!menu.scrolledState && menu.burgerStatus && barb !== 'homepage'){
                menu.showBurger.reverse();
            }



        },
        resize: function(){

        }
    },
    altMenu: {
        default: function(){
            $('.header-nav').removeClass('alt');
        },
        alt: function(){
            $('.header-nav').addClass('alt');
        }
    },
    scrollTo: function(){
        let hash = window.top.location.hash;
    }

};

page.main.v = {
    menuT1: null,
    menuT2: null,
   // showMenuItems: null,
    tableSlideTl: null,
    controller: null,
    mobileScrolled: false,
    wWidth:  $(window).width(),
    pageReady: false,
    nextPage: "",
    nextPageCallback: null
};

page.main.resize = function(){
    let f = page.main.f;
    let v = page.main.v;
    let magicScroll = page.main.fr.magicScroll;
    let wWidth = $(window).width();
    $.fn.matchHeight._update();

    f.initContMap();

    if(magicScroll.controller !== null && wWidth < 1024){
        magicScroll.destroy();
    }
    if(magicScroll.controller === null && wWidth >= 1024){
        magicScroll.init();
    }

    f.fixedBurger();
    if(v.wWidth !== wWidth){
        f.setScreenHeight();
    }

    //TODO
}

page.main.scroll = function(){
    page.main.f.scrolledLogo();
    page.main.fr.stupidMenu.checkScrolled();
    page.main.fr.stupidMenu.scroll();

}